export default __webpack_public_path__ + "8fb5782d6f5a8d2f30a7545e6caa5ffc.png";